import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export default function Markdown({ children, className = "" }) {
  return (
    <div className={`text-sm text-slate-700 leading-relaxed ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          p: ({ node, ...p }) => <p className="mb-2 last:mb-0" {...p} />,
          h1: ({ node, ...p }) => <h3 className="text-base font-bold text-slate-900 mt-3 mb-1.5" {...p} />,
          h2: ({ node, ...p }) => <h3 className="text-sm font-bold text-slate-900 mt-3 mb-1.5" {...p} />,
          h3: ({ node, ...p }) => <h4 className="text-sm font-semibold text-slate-800 mt-2 mb-1" {...p} />,
          ul: ({ node, ...p }) => <ul className="list-disc pl-5 space-y-1 mb-2" {...p} />,
          ol: ({ node, ...p }) => <ol className="list-decimal pl-5 space-y-1 mb-2" {...p} />,
          li: ({ node, ...p }) => <li className="text-slate-600" {...p} />,
          strong: ({ node, ...p }) => <strong className="font-semibold text-slate-900" {...p} />,
          code: ({ node, ...p }) => <code className="font-mono text-xs bg-slate-100 text-cyan-700 px-1 py-0.5 rounded" {...p} />,
          a: ({ node, ...p }) => <a className="text-cyan-600 underline" {...p} />,
          table: ({ node, ...p }) => <div className="overflow-x-auto my-2"><table className="text-xs border border-slate-200 rounded-lg" {...p} /></div>,
          th: ({ node, ...p }) => <th className="bg-slate-50 border border-slate-200 px-2 py-1 text-left font-semibold text-slate-600" {...p} />,
          td: ({ node, ...p }) => <td className="border border-slate-200 px-2 py-1 text-slate-600" {...p} />,
          blockquote: ({ node, ...p }) => <blockquote className="border-l-2 border-cyan-300 pl-3 italic text-slate-500 my-2" {...p} />,
        }}
      >
        {children || ""}
      </ReactMarkdown>
    </div>
  );
}
